/**
 * How many babies one household tracks. The server refuses more; setup and
 * Settings stop offering another row at it; and the server's read caps grow
 * with it.
 */

/** One baby, twins, or more. A guard against a runaway client: no real family reaches it. */
export const MAX_BABIES = 10;
